/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaFinanceReport } from '../../models/criteria-finance-report';

export interface ApiReportExportCreditDebitDailyPost$Params {
      body?: CriteriaFinanceReport
}

export function apiReportExportCreditDebitDailyPost(http: HttpClient, rootUrl: string, params?: ApiReportExportCreditDebitDailyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiReportExportCreditDebitDailyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiReportExportCreditDebitDailyPost.PATH = '/api/Report/ExportCreditDebitDaily';
